<template>
    <div class="outer-box">
        <div class="m-portlet  m-portlet--head-sm left  m-b-0">
            <div class="m-portlet__head">
                <div class="m-portlet__head-caption">
                    <div class="m-portlet__head-title">
                        <h3 class="m-portlet__head-text">
                            筛选条件
                        </h3>
                    </div>
                </div>
            </div>
            <div class="m-portlet__body m-portlet__body--small-padding ">
                <el-form label-position="top">
                    <el-form-item label="筛选团">
                        <el-select v-model="filter.student_id" clearable placeholder="请选择学生姓名" filterable remote
                                   :remote-method="handleSearchStudentName"
                                   @change="handleIndexTeam()">
                            <el-option
                                    v-for="item in students"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button @click="handleAddTeam()">新增团</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right m-b-0">
            <div class="m-portlet__body" :style="{'height':clientHeight-96-61.59+'px'}"  v-loading="loading">
                <el-table v-if="!loading"
                          :data="orderStudentTeams"
                          style="width: 100%"
                          :height="clientHeight-96-61.59-2.2-2-13-20"
                          size="middle">
                    <el-table-column prop="id" label="ID" min-width="10%"></el-table-column>
                    <el-table-column prop="name" label="团名" min-width="10%"> </el-table-column>
                    <el-table-column prop="member" label="成员数量" min-width="10%"></el-table-column>
                    <el-table-column prop="students" label="成员" min-width="40%"></el-table-column>
                    <el-table-column label="操作"  min-width="30%">
                        <template slot-scope="scope">
                            <el-button @click="handleAddStudent(scope.row.id)">添加成员</el-button>
                            <el-button @click="handleDeleteTeam(scope.row.id)">解散团</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <div class="m-portlet__foot">
                <!--分页-->
                <div class="text-center">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: '/student/team',
                loading: true,
                student_teams :{},
                total: 0,
                currentPage: 1,
                currentPageSize: 10,
                students: [],
                filter:{
                    student_id: '',
                },
                Dialogs_AddNewTeam:{
                    button_loading:false,
                },
                Dialogs_TeamAddStudent:{
                    button_loading:false,
                }
            }
        },
        props: {},
        components: {},
        created() {
            this.handleInit();
            this.handleIndexTeam();
            this.handleCreate();
        },
        beforeDestroy(){
            this.$wApi.removeListen(this.path)
        },
        computed: {
            powers(){
                return this.$store.state.config.powers;
            },
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
            orderStudentTeams: function () {
                return this._.values(this.student_teams);
            },
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData)
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.students =  data.students;
                        break;
                    case 'list':
                        if (Object.keys(data.student_teams).length > 0) {
                            this.student_teams = data.student_teams;
                        } else {
                            this.student_teams = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'searchStudent':
                        this.students = data.searchData;
                        break;
                    case 'store_new_team':
                        this.Dialogs_AddNewTeam.button_loading=false;
                        this.$set(this.student_teams,data.studentTeam.id,data.studentTeam)
                        this.$message({
                            type: 'success',
                            message: '添加成功!'
                        });
                        break;
                    case 'store_new_team_error':
                        this.Dialogs_AddNewTeam.button_loading=false;
                        break;
                    case 'go_into_team':
                        this.Dialogs_TeamAddStudent.button_loading=false;
                        this.$set(this.student_teams,data.studentTeam.id,data.studentTeam)
                        this.$message({
                            type: 'success',
                            message: '入团成功!'
                        });
                        break;
                    case 'go_into_team_error':
                        this.Dialogs_TeamAddStudent.button_loading=false;
                        break;
                    case 'delete_team':
                        this.$delete(this.student_teams,data.team_id)
                        break;
                }
            },
            handleInit() {
                this.$wApi.send(this.path, 'init', {})
            },
            handleIndexTeam(currentPage=1) {
                if (currentPage===1){
                    this.currentPage=1
                }
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': this.currentPageSize,
                    'filter': this.filter,
                });
            },
            handleSearchStudentName(query){
                this.$wApi.send(this.path, 'search', {
                    'type':'studentKeyName',
                    'studentKeyName': query,
                })
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.loading = true;
                this.handleIndexTeam(this.currentPage)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.loading = true;
                this.handleIndexTeam(this.currentPage)
            },
            handleAddTeam(){
                this.$Win.openModal('Dialogs_AddNewTeam', 400, 500, '新建团', {});
            },
            handleAddStudent(team_id){
                this.$Win.openModal('Dialogs_TeamAddStudent', 400, 500, '入团', {'team_id':team_id});
            },
            handleDeleteTeam(team_id){
                this.$confirm('确认解散改团?', '提示', {
                    StartReturn: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'delete_team', {
                        'team_id':team_id,
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    });
                });
            },
        }
    }
</script>

<style scoped lang="scss">
    .left {
        float: left;
        width: 220px;
    }

    .right {
        margin-left: 225px;
    }
</style>
